import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import './ProgressIndicator.css';

class ProgressIndicator extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isSlowVisible: false
        };
    }

    componentDidMount() {
        this.setState({
            timer: setTimeout(() => {
                this.setState({ isSlowVisible: true });
            }, 3000)
        });
    }

    componentWillUnmount() {
        clearTimeout(this.state.timer);
    }

    render() {
        return (
            <Container>
                <Row>
                    <Col className="py-3 text-center">
                        <div className="lds-dual-ring"/>
                        <span className="sr-only">Letöltés folyamatban.</span>
                        {this.state.isSlowVisible && <div className="text-color">Még egy kis türelmet...</div>}
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ProgressIndicator;
